export default __webpack_public_path__ + "static/media/Ambit-Regular.5e94d30e.woff";